import 'Styles/templates/collection.build-your-kit.scss';

import BuildYourKit from '../vue/collection-build-your-kit/index';

BuildYourKit();